import React from "react";
import { SerializedCondition } from "../types";
import useSharedSchedules from "@/hooks/useSharedSchedules";

export type SharedScheduleCondition = {
  scheduleId: number;
};

export function SharedScheduleEditor({
  condition,
  onUpdate
}: {
  condition: SerializedCondition;
  onUpdate: (condition: SerializedCondition) => void;
}) {
  const { schedules } = useSharedSchedules();
  const parsed = JSON.parse(condition.data || "{}") as SharedScheduleCondition;

  function update(scheduleId: number) {
    onUpdate({ ...condition, data: JSON.stringify({ scheduleId }) });
  }

  return (
    <div className="flex flex-col gap-1">
      <select
        className="input w-full"
        value={parsed.scheduleId ?? ""}
        onChange={(e) => update(Number(e.target.value))}
      >
        <option value="">— select a schedule —</option>
        {schedules.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </select>
      {schedules.length === 0 && (
        <p className="text-xs text-gray-400">
          No schedules yet. Create one under Settings → Schedules.
        </p>
      )}
    </div>
  );
}
